import {
  setEmailSubscriptionCenterProfileCookie,
  setProfileCookie,
} from '../../../global/authentication/authentication-manager'
import { goToSecurePageRedirect } from '../../../global/authentication/url-redirector'
import {
  postCheckSubscription,
  setContactKey,
} from '../../EmailSubscriptionCenter/Data/SubscriptionCenterDataSource'
import { getSecureProfile } from '../Data/LoginDatasource'

export const callProfileService = async (handleProfileErrorResponse) => {
  const _profileData = await getSecureProfile()

  if (_profileData.error) {
    handleProfileErrorResponse(_profileData.error)
  } else {
    const profileData = _profileData.value
    if (window._satellite) {
      window._satellite.track('login_success_ctn')
    }
    setEmailSubscriptionCenterProfileCookie(profileData)
    try {
      const subData = await postCheckSubscription()
      if (subData.value) {
        if (subData.value.contactID) {
          setContactKey(subData.value.contactID)
        }
      }
    } catch (error) {
      console.error('Subscription center sign in error', error)
    }

    // to not increment the salesforce counter
    setProfileCookie()

    goToSecurePageRedirect()
  }
}
